'use client';

import { useTranslations } from "next-intl";
import React from 'react';

import IconSvg from "@/assets/svg/icons/DentalLab.svg";

export default function IconDentalLab() {
	const t = useTranslations('page.r-bg-dental-procedure-codes-catalog');

	return (
		<div
			className="d-inline-block"
			data-bs-toggle="tooltip"
			data-placement="top"
			data-bs-title={t('common-tooltip.lab')}
		>
			<IconSvg
				className="me-2"
				height="20"
				width="20"
				alt={t('common-tooltip.lab')}
			/>
		</div>
	);
}
